// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"141":"bf013e8f","675":"805ab4fc","677":"4704c836","695":"078ee61e","958":"1643eb9e"}[chunkId] + ".chunk.js";
};